<app-header />

<section id="intro" class="d-flex align-items-center justify-content-center">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-xl-5 fs-6 intro-content">
        <h1>We are AUTOLOOP</h1>
        <p>
            Your trusted partner in vehicle scrapping and recycling services.
        </p>
      </div>
      <div class="col-xl-6 ms-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section>

<!-- <section class="section bg-dark">
  <div class="container works-slider">
    <h2 class="mb-5 text-white text-primary text-center">
      How Scrapping Works
    </h2>
    <swiper-container class="d-block w-100" id="scrapping_view" init="false">
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-1.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-1.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Old Vehicle</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-2.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-2.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Vehicle Picked Up</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-3.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-3.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Dismantling</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-4.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-1.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Recycle</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-1.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-1.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Old Vehicle</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-2.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-2.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Vehicle Picked Up</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-3.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-3.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Dismantling</span>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="rounded-4 overflow-hidden mb-4">
          <img
            src="/hero/scrap-4.jpg"
            class="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center justify-content-center gap-2">
          <img src="/svg/w-1.svg" alt="" />
          <span class="fs-6 fw-semibold text-primary">Recycle</span>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</section> -->

<app-footer />
